/************************************************************
 * Primitive Definitions
 */
const __FONT_SIZE__ = {
  fs12: '0.75rem',
  fs14: '0.875rem',
  fs16: '1rem',
  fs18: '1.125rem',
  fs22: '1.375rem',
  fs26: '1.625rem',
  fs30: '1.875rem',
} as const

/************************************************************
 * Semantic Definitions
 */
const __SEMANTIC_FONT_SIZE__ = {
  xxs: __FONT_SIZE__.fs12,
  xs: __FONT_SIZE__.fs14,
  sm: __FONT_SIZE__.fs16,
  md: __FONT_SIZE__.fs18,
  lg: __FONT_SIZE__.fs22,
  xl: __FONT_SIZE__.fs26,
  xxl: __FONT_SIZE__.fs30,
} as const

/************************************************************
 * Export
 */
export const FONT_SIZE = Object.freeze({
  ...__FONT_SIZE__,
  ...__SEMANTIC_FONT_SIZE__,
})
